import type { MouseEvent as ReactMouseEvent } from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { Grid, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'

import type { Estimate } from '~/types'

const useStyles = makeStyles(
  (theme) => ({
    moreIconButton: {
      padding: theme.spacing(1, 0.5),
    },
  }),
  { name: 'MoreEstimateInfoDropdown' },
)

interface MoreEstimateInfoDropdownProps {
  actionsAnchorElement: HTMLElement | null
  activeActionItem: string | null
  estimate: Estimate
  setActionsAnchorElement: (element: HTMLElement | null) => void
  setActiveActionItem: (item: string | null) => void
}

const MoreEstimateInfoDropdown = ({
  actionsAnchorElement,
  activeActionItem,
  setActionsAnchorElement,
  setActiveActionItem,
  estimate,
}: MoreEstimateInfoDropdownProps) => {
  const classes = useStyles()

  const handleToggleActions = (event: ReactMouseEvent) => {
    event.stopPropagation()

    const targetButton = (event.target as HTMLElement).closest('button')
    setActionsAnchorElement(actionsAnchorElement ? null : targetButton)
    setActiveActionItem(activeActionItem ? null : estimate.id)
  }

  return (
    <Grid container alignItems="center" justifyContent="center" wrap="nowrap">
      <IconButton
        classes={{
          root: classes.moreIconButton,
        }}
        onClick={(event) => handleToggleActions(event)}
      >
        <MoreHorizIcon />
      </IconButton>
    </Grid>
  )
}

export default MoreEstimateInfoDropdown
